// assets/blog.js

document.addEventListener('DOMContentLoaded', () => {
  const tagFilter = document.getElementById('BlogTagFilter');
  if (tagFilter) {
    tagFilter.addEventListener('change', (event) => {
      const url = event.target.value;
      if (url) window.location.href = url;
    });
  }
});
